import { THLBoardActions } from './hl-board.actions';
import { THLBoardInfoActionType, THLBoardState } from './hl-board.models';

export const initialState: THLBoardState = {
  hlBoardList: null,
  OTLCapacitiesInfo: null,
  WeeklyOPLCapacitiesInfo: null,
  DailyOTLCapacitiesInfo: null,
};

export function hlBoardReducer(state = initialState, action: THLBoardActions): THLBoardState {
  switch (action.type) {
    case THLBoardInfoActionType.GetHLBoardListSuccess:
      return {
        ...state,
        hlBoardList: action.payload,
      };
    case THLBoardInfoActionType.GetOTLCapacitiesInfoSuccess:
      return {
        ...state,
        OTLCapacitiesInfo: action.payload,
      };
    case THLBoardInfoActionType.GetWeeklyOPLCapacitiesInfoSuccess:
      return {
        ...state,
        WeeklyOPLCapacitiesInfo: action.payload,
      };
    case THLBoardInfoActionType.GetDailyOPLCapacitiesInfoSuccess:
      return {
        ...state,
        DailyOTLCapacitiesInfo: action.payload,
      };
    default:
      return state;
  }
}
